export const selectInsuranceType = state => {
  if (!state || !state.quoteQuickStart) return "100";
  return state.quoteQuickStart.insuranceType;
};
